import React from 'react';
import { Divider as AntDivider, DividerProps as AntDividerProps } from 'antd';
import { createUseStyles } from 'react-jss';
import { ThemeType } from 'src/theming/jssTypes';

export interface DividerProps extends AntDividerProps {
  className?: string;
}

const useStyles = createUseStyles((theme: ThemeType) => ({
  divider: {
    borderColor: `${theme.color.semantic.border.primary} !important`,
    borderWidth: theme.border.width.sm,
    margin: `${theme.spacing[0]} ${theme.spacing[2]}`,
    '&.ant-divider-with-text': {
      color: theme.color.semantic.text.primary,
      fontSize: theme.typography.fontSize.sm,
      fontWeight: theme.typography.fontWeight.regular,
    },
  },
}));

const Divider: React.FC<DividerProps> = ({ className = '', ...rest }) => {
  const classes = useStyles();
  return <AntDivider {...rest} className={`${classes.divider} ${className}`.trim()} />;
};

export default Divider;
